import { BranchesList } from './BranchesList.main';

export { BranchesList };
